import { useEffect, useState } from 'react';
import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { RegulationTabs } from '../../components/Tab/Tabs';
import { fetchGet } from '../../hooks/fetch';

export default function Policy() {
	const pageName = '개인정보 처리방침';
	const [tabsData, setTabsData] = useState([]);
	
		function getPage() {
			fetchGet(
				`/regulation?type=POLICY`,
				(json) => setTabsData(json)
			)
		}
	
		useEffect(() => {
			getPage();
		}, []);

	return (
		<main id="policy-page-wrap" className="policy">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<div className="page-content">
					<RegulationTabs tabsData={tabsData} className="gs-sub-tab-con line" />
				</div>
			</Container>
		</main>
	);
}

